import { Button, message, Tabs } from "antd";
import React, { Component } from "react";
import { connect } from "react-redux";

import { AxiosGetSecretApi } from "../../../../../utils/fetchApi";
import StaticClass from "../../../../../utils/staticClass";
import { LocalStore } from '../../../../../utils/LocalStore/index';
// import
class SearchResultChiTiet extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activeTab: "DuAn",
      dataSuDungDat: [],
      data: [],
      isRender: false,
      isShowLocation: false,
    };

    this.listDuAnTitle = [
      "Mã dự án",
      "Quận/Huyện",
      "Phường/Xã",
      "Tên dự án",
      "Diện tích (ha)",
      "Chủ đầu tư",
      "Điều hành dự án",
      "Tiến độ",
      "Quyết định pháp lý",
      "Năm ra quyết định",
      "Ghi chú",
      "Năm quy hoạch",
    ];

    this.listDuAnValue = [
      "Madoan",
      "TENHUYEN",
      "TenPhuong",
      "Tendoan",
      "DienTich",
      "Chudautu",
      "Dieuhanhduan",
      "TinhTrang",
      "Quyetdinhphaply",
      "NamraQDphaply",
      "GhiChu",
      "NamQH",
    ];

    this.listTienDo = [
      {
        value: 0,
        name: "-",
      },
      {
        value: 1,
        name: "Cơ bản hoàn thành",
      },

      {
        value: 2,
        name: "Đang triển khai",
      },

      {
        value: 3,
        name: "Chưa triển khai",
      },

      {
        value: 4,
        name: "Chậm triển khai",
      },
    ];
  }

  componentDidMount() {
    this.getDataDuAn();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.data !== this.props.data) {
      console.log(prevProps.data, this.props.data);
      this.getDataDuAn();
      this.props.hidePoint()
      this.setState({
        isShowLocation: false
      })
    }
  }

  changeTab(e) {
    this.setState({
      activeTab: e,
    });
  }

  async getDataSuDungDat(id) {
    let res = await AxiosGetSecretApi(`/api/duanqh/danhsach-sd-dat?id=${id}`);
    if (res && Array.isArray(res) && res.length !== 0) {
      this.setState({
        dataSuDungDat: res,
      });
    } else {
      this.setState({
        dataSuDungDat: [],
      });
    }
  }

  async getDataDuAn() {
    if (this.props.data) {
      let id = undefined;
      if (this.props.isEnableLayer.includes("QHCT_Polygon")) {
        id = this.props.data.MaDuAn;
      } else {
        if (this.props.isEnableLayer.includes("QHCT_RanhGioi") || this.props.isEnableLayer.includes("QHCT_Line")) {
          id = this.props.data.Madoan;
        }
      }
      if (id && id !== "null" && id !== "Null") {
        this.getDataSuDungDat(id);
        let res = await AxiosGetSecretApi(
          `/api/duanqh/search?curPage=1&pageSize=10&OBJECTID=${id}`
        );
        if (
          res &&
          res.dataResult &&
          Array.isArray(res.dataResult) &&
          res.dataResult.length > 0
        ) {
          this.setState({
            data: res.dataResult[0],
            isRender: true,
            geoData: { SHAPE: res.dataResult[0].Shape },
          });
          this.getGeoData(res.dataResult[0].OBJECTID_1);
          return;
        }
      }
    }

    message.error("Chưa có thông tin (Dữ liệu đang cập nhật)");
    this.setState({
      isRender: false,
    });
  }

  async getGeoData(id) {
    let res = await AxiosGetSecretApi(
      `https://gis-quyhoach.greenglobal.vn/server/rest/services/SoXayDung/QuyHoachDoThi/MapServer/7/query?f=json&where=1%3D1&returnGeometry=true&spatialRel=esriSpatialRelIntersects&objectIds=${id}&outFields=*&outSR=102100`
    );
    if (
      res &&
      res.features &&
      Array.isArray(res.features) &&
      res.features.length !== 0 &&
      res.features[0].geometry &&
      res.features[0].geometry.rings
    ) {
      this.props.drawRing(res.features[0].geometry.rings);
    }
  }

  showLocation() {
    if (this.state.isShowLocation) {
      this.props.hidePoint();
    } else {
      this.props.showPoint(this.state.geoData);
      setTimeout(() => {
        document
          .getElementById("listlocation")
          .scrollIntoView({ behavior: "smooth" });
      }, 50);
    }
    this.setState({
      isShowLocation: !this.state.isShowLocation,
    });
  }

  render() {
    console.log('render', 'SearchResultChiTiet');
    const dataTable = this.state.dataSuDungDat.map((o, i) => {
      return (
        <tr key={i}>
          <td style={{ width: "45px", textAlign: "center" }}>{i + 1}</td>
          <td style={{ width: "135px", textAlign: "left" }}>{o.LoaiDat}</td>
          <td style={{ width: "95px", textAlign: "left" }}>{StaticClass.formatPrice(o.DienTich)}</td>
          <td style={{ width: "55px", textAlign: "center" }}>{StaticClass.formatPrice(o.TyLe)}</td>
        </tr>
      );
    });
    return (
      <>
        {this.state.isRender && (
          <div className="search-result-lop-du-lieu">
            <div className="search-500-header">
              Thông tin dự án quy hoạch 1/500
              <i className="fas fa-times icon-close" onClick={this.props.close}></i>
            </div>

            <Tabs defaultActiveKey="1">
              <Tabs.TabPane
                key="1"
                tab={
                  <div
                    style={{
                      width: "170px",
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    Dự án
                  </div>
                }
              >
                <div className="search-500-body">
                  <div>
                    {this.listDuAnTitle.map((e, i) => (
                      <div style={{ display: "flex" }} key={i}>
                        <div className="col-left search-500-text" style={{marginRight: 0, width: 145}} >
                          {e}:
                        </div>

                        <div className="col-right search-500-text-gray"style={{maxWidth: 185}} >
                          {this.state.data[`${this.listDuAnValue[i]}`] &&
                          this.state.data[`${this.listDuAnValue[i]}`] !==
                            "null" &&
                          this.state.data[`${this.listDuAnValue[i]}`] !== "Null"
                            ? i === 7
                              ? Number.isInteger(this.state.data[`${this.listDuAnValue[i]}`])
                                ? this.listTienDo[this.state.data[`${this.listDuAnValue[i]}`]].name
                                : "-"
                              : i === 4 
                                ? StaticClass.formatPrice(this.state.data[`${this.listDuAnValue[i]}`]) 
                                : this.state.data[`${this.listDuAnValue[i]}`]
                            : "-"}
                        </div>
                      </div>
                    ))}

                    {this.props.file && (
                      <div style={{ display: "flex" }}>
                        <div className="col-left search-500-text" style={{marginRight: 0, width: 145}}>
                          File đính kèm:
                        </div>
                        <div>
                          {this.props.file.map((e, i) => (
                            <div
                              key={i}
                              className="col-right search-500-text"
                              style={{
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                maxWidth: "125px",
                                maxWidth: 185
                              }}
                            >
                              <a href={e.Duongdanfiledinhkem}>
                                {e.Tenfiledinhkem}
                              </a>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                  { localStorage.loginSession && <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      marginBottom: "10px",
                    }}
                  >
                    <Button
                      type="primary"
                      className="search-result-button"
                      onClick={() => this.showLocation()}
                    >
                      {this.state.isShowLocation ? "Ẩn toạ độ" : "Hiện toạ độ"}
                    </Button>
                  </div>}

                  {this.state.isShowLocation ? (
                    <div
                      style={{
                        textAlign: "center",
                        maxHeight: "300px",
                        overflow: "auto",
                        marginBottom: "10px",
                        padding: "0 10px 10px 10px",
                      }}
                    >
                      <table style={{ width: "100%" }}>
                        <tbody>
                          <tr>
                            <th
                              style={{
                                border: "1px solid #a3a3a3",
                                width: "80px",
                              }}
                            >
                              Số hiệu góc thửa
                            </th>
                            <th style={{ border: "1px solid #a3a3a3" }}>
                              X(m)
                            </th>
                            <th style={{ border: "1px solid #a3a3a3" }}>
                              Y(m)
                            </th>
                          </tr>
                          {this.state.geoData &&
                            this.state.geoData.SHAPE &&
                            this.state.geoData.SHAPE.length === undefined &&
                            this.state.geoData.SHAPE.points.map(
                              (o, index, arr) => {
                                if (
                                  index <
                                  this.state.geoData.SHAPE.points.length - 1
                                )
                                  return (
                                    <tr key={index}>
                                      <td
                                        style={{ border: "1px solid #a3a3a3" }}
                                      >
                                        {index + 1}
                                      </td>
                                      <td
                                        style={{ border: "1px solid #a3a3a3" }}
                                      >
                                        {StaticClass.formatNumberFloat(o.x)}
                                      </td>
                                      <td
                                        style={{ border: "1px solid #a3a3a3" }}
                                      >
                                        {StaticClass.formatNumberFloat(o.y)}
                                      </td>
                                    </tr>
                                  );
                              }
                            )}
                          {this.state.geoData &&
                            this.state.geoData.SHAPE &&
                            this.state.geoData.SHAPE.length &&
                            this.state.geoData.SHAPE.map((e, index1) => {
                              return (
                                <>
                                  {e.points.map((p, index, arr) => {
                                    return (
                                      <tr key={index}>
                                        <td
                                          style={{
                                            border: "1px solid #a3a3a3",
                                          }}
                                        >
                                          {index === arr.length - 1
                                            ? 1
                                            : index + 1}
                                        </td>
                                        <td
                                          style={{
                                            border: "1px solid #a3a3a3",
                                          }}
                                        >
                                          {StaticClass.formatNumberFloat(p.y)}
                                        </td>
                                        <td
                                          style={{
                                            border: "1px solid #a3a3a3",
                                          }}
                                        >
                                          {StaticClass.formatNumberFloat(p.x)}
                                        </td>
                                      </tr>
                                    );
                                  })}
                                </>
                              );
                            })}
                        </tbody>
                      </table>
                    </div>
                  ) : null}

                  <div id="listlocation"> </div>
                </div>
              </Tabs.TabPane>

              <Tabs.TabPane
                key="2"
                tab={
                  <div
                    style={{
                      width: "170px",
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    Chi tiết sử dụng đất
                  </div>
                }
              >
                <div className="search-500-body">
                  {this.state.activeTab === "DuAn" && (
                    <div>
                      {this.state.dataSuDungDat.length !== 0 ? (
                        <div>
                          <table>
                            <tbody>
                              <tr>
                                <th
                                  style={{ width: "45px", textAlign: "center" }}
                                >
                                  STT
                                </th>
                                <th
                                  style={{
                                    width: "135px",
                                    textAlign: "center",
                                  }}
                                >
                                  Loại đất
                                </th>
                                <th
                                  style={{ width: "95px", textAlign: "center" }}
                                >
                                  Diện tích (m²)
                                </th>
                                <th
                                  style={{ width: "55px", textAlign: "center" }}
                                >
                                  {" "}
                                  Tỷ lệ (%)
                                </th>
                              </tr>
                              {dataTable}
                            </tbody>
                          </table>
                        </div>
                      ) : (
                        <div style={{ textAlign: "center" }}>
                          Chưa có thông tin
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </Tabs.TabPane>
            </Tabs>
          </div>
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isEnableLayer: state.map.isEnableLayer,
  };
};

const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SearchResultChiTiet);
